import React from "react"
import styled from "styled-components"

const StyledParagraph = styled.p`
  color: ${props => props.theme.colors.grey};
  line-height: 1.8;
`

export default function Address() {
  return (
    <div>
      <StyledParagraph>Origin Restaurant</StyledParagraph>
      <StyledParagraph>4 Kilo, behind Ambassador</StyledParagraph>
      <StyledParagraph>Addis Ababa, Ethiopia</StyledParagraph>
    </div>
  )
}
